import { IDevice } from "@formant/core/model/IDevice";

import { videoIpDevicesForDevices } from "../component/Observe/utils/videoIpDevicesForDevices";
import { videoUsbDevicesForDevices } from "../component/Observe/utils/videoUsbDevicesForDevices";

export function videoPathsMapForDevices(devices: IDevice[] | undefined) {
    const usb = videoUsbDevicesForDevices(devices).reduce<{
        [id: string]: string;
    }>(
        (acc, videoDevice) => ({
            ...acc,
            [`${videoDevice.name} - ${videoDevice.path}`]: videoDevice.path,
        }),
        {},
    );
    const ip = videoIpDevicesForDevices(devices).reduce<{
        [id: string]: string;
    }>(
        (acc, videoDevice) => ({
            ...acc,
            [`${videoDevice.name} - ${videoDevice.address}`]:
                videoDevice.address,
        }),
        {},
    );
    return { usb, ip };
}
